import React from 'react';
import classNames from 'classnames';
import styles from './index.module.less';

interface PageWrapperProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  flex?: boolean;
}

const PageWrapper: React.FC<PageWrapperProps> = ({ flex = true, children, className, ...rest }) => {
  return (
    <div {...rest} className={classNames(styles.pageWrap, { [styles.flex]: flex }, className)}>
      {children}
    </div>
  );
};

export default PageWrapper;
